import { Injectable } from '@angular/core';
import { IdProcedimiento } from '../models/IdProcedimiento';

@Injectable({
  providedIn: 'root'
})
export class ApiParametrosService {

  private correoUsuario: string = '';
  private passUsuario: string = '';

  private idProcedimiento: IdProcedimiento;

  constructor() { }

  getCorreo() {
    return this.correoUsuario;
  }

  getPass() {
    return this.passUsuario;
  }

  setDatosUsuario(correo: string, pass: string) {
    this.correoUsuario = correo;
    this.passUsuario = pass;
  }

  /*GET ID Procedimiento*/
  setIdProcedimiento(id: string, anio: string) {
    this.idProcedimiento = {
      anio: anio,
      id: id
    }; 
  }

  /*SET ID Procedimiento*/
  getIdProcedimiento(): IdProcedimiento {
    return this.idProcedimiento;
  }

}
